import React from "react";
import PharmacyOrderItemMobile from "./PharmacyOrderItem/PharmacyOrderItemMobile";

const PharmacyOrdersListMobile = (props) => {
  const { orders } = props;
  console.log(orders);
  const renderItem = (item, index) => {
    // console.log("item in desktop", item)
    if (Array.isArray(item)) {
      console.log("item", item);
      return (
        <div
          className={
            "batch-order-holder " +
            (index % 2 === 0
              ? "batch-order-holder-gray"
              : "batch-order-holder-blue")
          }
          key={item.id}
        >
          {item.map((order, index) => {
            return <PharmacyOrderItemMobile key={order.id} {...order} />;
          })}
        </div>
      );
    } else {
      return <PharmacyOrderItemMobile key={item.id} {...item} />;
    }
  };
  return (
    <div className="lab-orders-list">
      {orders.map((order, index) => {
        return renderItem(order, index);
      })}
    </div>
  );
};
export default PharmacyOrdersListMobile;
